<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-06 10:53:41
 * @LastEditTime: 2019-08-09 17:24:11
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div class="container" v-loading='loading'>
          <div class="pageTitle">查看详情</div>
        <el-form ref="form"  label-width="80px">
  <el-form-item label="订单状态:">
           <span v-if="list.status == 0">未发货</span>
                                <span v-if="list.status == 1">已发货</span>
                                <span v-if="list.status == 2">部分发货</span>
                                <span v-if="list.status == 3">待付款</span>
                                <span v-if="list.status == 4">待审核</span>
                                <span v-if="list.status == 5">审核不通过</span>
                                <span v-if="list.status == 6">已完成</span>
                                <span v-if="list.status == 7">已取消</span>
  </el-form-item>
  <el-form-item label="订单号:">
  {{$route.query.id}}
  </el-form-item>
  <el-form-item label="订货经销商:">
   {{list.to_name}}
  </el-form-item>
  <el-form-item label="订货经销商级别:">
  {{list.to_level_name}}
  </el-form-item>
  <el-form-item label="手机:">
  {{list.to_mobile}}
   
  </el-form-item>
  <el-form-item label="收货地址:">
  {{list.to_address}}
  </el-form-item>
  <el-form-item label="支付方式:">
  {{pay_text[list.pay_type]}}
      
  </el-form-item>
  <el-form-item label="是否赠品:">
  {{list.isgift==1?'赠品':'非赠品'}}
    
  </el-form-item>
    <el-form-item label="订单留言:">
  {{list.order_notes}}
    
  </el-form-item>
   <el-form-item label="产品清单:">
        <el-table
      :data="list.products"
      border
      style="width: 100%">
      <el-table-column
        prop="product_sn"
        label="产品编号"
       >
      </el-table-column>
      <el-table-column
        prop="product_name"
        label="产品名称"
        >
      </el-table-column>
      <el-table-column
        prop="product_specs"
        label="产品规格">
      </el-table-column>
        <el-table-column
        prop="attribute_name"
        label="商品属性">
      </el-table-column>
          <el-table-column
        prop="last_price"
        label="订货价">
      </el-table-column>
       <el-table-column
        prop="stock_out_num"
        label="数量">
      </el-table-column>
    </el-table>
  </el-form-item>
   <el-form-item label="发货仓库:">
  {{list.warehouse_name}}
    
  </el-form-item>
   <el-form-item label="订单发货明细:" v-if='isCodeShow'>
          <el-table
      :data="list.product_batchs"
      border
      style="width: 100%">
        <el-table-column
        prop="product_batch"
        label="生产批次号"
       >
      </el-table-column>
      <el-table-column
        prop="product_sn"
        label="产品编号"
       >
      </el-table-column>
      <el-table-column
        prop="product_name"
        label="产品名称"
        >
      </el-table-column>
      <el-table-column
        prop="product_specs"
        label="产品规格">
      </el-table-column>
       <el-table-column
        prop="stock_out_num"
        label="数量">
      </el-table-column>
    </el-table>
  </el-form-item>

</el-form>
<div style='margin:10px;text-align:right'>订单金额:<span style='color:red'>￥{{all}}</span>  </div>

<div class="btns">
    <el-button @click='back'>返回列表</el-button>
</div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            loading:false,
            list:[],
            isCodeShow:false,
            all:0,
            pay_text:['','线下支付','微信支付','微信扫码支付'],
        }
    },
    methods:{
     
        getDetail(){
            this.loading=true
            
            var url='/shops.orders/'+this.$route.query.id
            this.$get('logistics',url).then(res=>{
                this.list=res.data
                this.loading=false
                this.all=res.data.total_price
            })
        },
        back(){
            this.$router.go(-1)
        },
          getConfigInfo(){
                this.$get('logistics', '/configs', {
                    lang: ''
                }).then(res => {
                    
                    if(res.data.production_batch_on_off == 0){
                        this.isCodeShow = false;

                    }else if(res.data.production_batch_on_off == 1){
                        this.isCodeShow = true;
                        // this.getCount()
                    }
                }).catch(function (error) {
                    console.log(error);
                       this.$message({
                                type: 'error',
                                message: error.message
                            });
            this.loading=false
                });
            }
    },
    created(){
        this.getConfigInfo()
        this.getDetail()
    }

}
</script>


<style lang="scss" scoped>
/deep/.el-form-item{
    margin-bottom: 10px!important;
    .el-form-item__label{width: 150px!important;}
} 
.btns{
    text-align: center;
}
</style>
